module.exports = __webpack_public_path__ + "img/symposium_login.e68c2585.webp";